// @flow

import React, { Component } from 'react';

import type { StatelessFunctionalComponent } from 'react';
import type { SellerReviewsModalProps } from './SellerReviewsModal';
type SellerReviewsModalAsyncState = {
    SellerReviewsModal: ?StatelessFunctionalComponent<SellerReviewsModalProps>,
};

export class SellerReviewsModalAsync extends Component<
    SellerReviewsModalProps,
    SellerReviewsModalAsyncState
> {
    constructor(props: SellerReviewsModalProps) {
        super(props);
        this.state = { SellerReviewsModal: null };
        this.loadComponent = this.loadComponent.bind(this);
    }

    componentDidMount() {
        if (this.props.isOpen) {
            this.loadComponent();
        }
    }

    componentDidUpdate() {
        if (this.props.isOpen && !this.state.SellerReviewsModal) {
            this.loadComponent();
        }
    }

    loadComponent: () => void;
    loadComponent() {
        import(/* webpackChunkName: "SellerReviewsModal" */ './SellerReviewsModal').then(mod => {
            this.setState(() => ({ SellerReviewsModal: mod.SellerReviewsModal }));
        });
    }

    render() {
        const { SellerReviewsModal } = this.state;
        if (!SellerReviewsModal) {
            return null;
        }
        return <SellerReviewsModal {...this.props} />;
    }
}
